import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Client, Manager } from '@/api/profile';
import { profileColor, profileAbb } from '@/api/graphicIdentifier';

@Component({
})
export default class ManagerInfo extends Vue {
    @Prop() profile!: Manager
    get profileColor() {
        return profileColor(this.profile.fio)
    }
    get profileAbb() {
        return profileAbb(this.profile.fio)
    }
}